import { render, staticRenderFns } from "./ProductionReportInformation.vue?vue&type=template&id=a1470250&scoped=true&"
import script from "./ProductionReportInformation.vue?vue&type=script&lang=js&"
export * from "./ProductionReportInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductionReportInformation.vue?vue&type=style&index=0&id=a1470250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1470250",
  null
  
)

component.options.__file = "ProductionReportInformation.vue"
export default component.exports